import { InteractiveMeshElement } from "../Components/BakedMeshComponents"

import {
  useApartmentBedsByPlotNumber,
  useApartmentStatusByPlotNumber,
  useBlocks
} from "../Utils/hooks"
import { useAvailableApartments } from "../Utils/hooks"

function InteractiveBuilding({ buildingID }) {
  const pathToGLTF = `interactiveBuildings/${buildingID}/${buildingID}`
  console.log(pathToGLTF)
  const bedIndex = useApartmentBedsByPlotNumber()
  const statusIndex = useApartmentStatusByPlotNumber()
  const availableApartments = useAvailableApartments()

  const availableIndex = []

  availableApartments.forEach(ap => availableIndex.push(Number(ap.PlotNumber)))
  const blocks = useBlocks({ pathToGLTF })
  const blocksArr = Object.values(blocks)

  console.log(blocks)

  return (
    <>
      {blocksArr.map((b, index) => (
        <InteractiveBlock
          key={index}
          blocks={b}
          id={index}
          statusIndex={statusIndex}
          bedIndex={bedIndex}
          availableIndex={availableIndex}
        />
      ))}
    </>
  )
}

function InteractiveBlock({ blocks, id, bedIndex, statusIndex, availableIndex }) {
  return (
    <group>
      {blocks.map((b, i) => (
        <InteractiveMeshElement
          name={b.name}
          key={i}
          mesh={b.geometry}
          center={b.geometry.boundingSphere.center}
          //
          bedIndex={bedIndex}
          statusIndex={statusIndex}
          availableIndex={availableIndex}
        />
      ))}
    </group>
  )
}

export default InteractiveBuilding
